import { lazy, type ComponentType, type LazyExoticComponent } from 'react';

export const lazyWithRetry = <T extends ComponentType<any>>(
  importFunc: () => Promise<{ default: T }>,
  name: string, // Unique component name for sessionStorage tracking
): LazyExoticComponent<T> => {
  return lazy(
    () =>
      new Promise<{ default: T }>((resolve, reject) => {
        const hasRefreshed = sessionStorage.getItem(`retry-${name}-refreshed`) === 'true';

        importFunc()
          .then((component) => {
            sessionStorage.setItem(`retry-${name}-refreshed`, 'false'); // Reset flag after success
            resolve(component);
          })
          .catch((error) => {
            if (!hasRefreshed) {
              sessionStorage.setItem(`retry-${name}-refreshed`, 'true');
              window.location.reload(); // Force reload
            } else {
              reject(error); // Reject after refresh attempt
            }
          });
      }),
  );
};
